import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function CustomTooltip({ tooltipIcon, tooltipContent }) {
    const renderTooltip = (props) => (
        <Tooltip className="custom-tooltip" id="button-tooltip" {...props}>
            {tooltipContent}
        </Tooltip>
    );

    return (
        <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
        >
            <span className="custom-tooltip-icon" role="button">{tooltipIcon}</span>
        </OverlayTrigger>
    );
}

export default CustomTooltip;